import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { SharedService } from '../../shared/shared.service';
import { Roles, SweetAlertIcon } from '../../shared/constants/enum';
import { MENU } from '../../layouts/rp-sidebar/menu';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private authenticationService: AuthenticationService
  ) {}

  private normalizeRole(role?: string): string {
    return (role || '').toString().toLowerCase().replace(/\s+/g, '');
  }

  private checkUserRole(role: string, url: string): boolean {
    const menuItem = MENU.find((item) => item.link === url);
    const normalizedRole = this.normalizeRole(role);
    const hasRole = menuItem?.roles.some(
      (menuRole:any) => this.normalizeRole(menuRole) === normalizedRole
    );

    if (menuItem && hasRole) {
      this.sharedService.closeDialog();
      return true;
    }
    return false;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    const token = localStorage.getItem('token');
    const currentUser = this.authenticationService.currentUserValue;

    //  FIX: check token + user
    if (!token || !currentUser) {
      this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    const url = state.url.split('?')[0];

    return this.sharedService.getCurrentUser().pipe(
      take(1),
      map((user) => {
        const userRole = user?.currentUserRoleDetails?.role;
        const normalizedRole = this.normalizeRole(userRole);
        const normalizedAdmin = this.normalizeRole(Roles.ADMIN);
        const normalizedDashboardAdmin = this.normalizeRole(
          Roles.DASHBOARDADMIN
        );
        const normalizedEvAdmin = this.normalizeRole(Roles.EVADMIN);
        const normalizedSgld = this.normalizeRole(Roles.SGLDADMIN);
        const normalizedSuperAdmin = this.normalizeRole(Roles.SUPERADMIN);
        const normalizedSuperUser = this.normalizeRole(Roles.SUPERUSER);
        const normalizedConsumer = this.normalizeRole(Roles.CONSUMER);
        const normalizedAgentAdmin = this.normalizeRole(Roles.AGENTADMIN);

        if (userRole && this.checkUserRole(userRole, url)) {
          return true;
        }

        //  Role-based redirects
        this.sharedService.showMessageDialog(
          'Access Denied',
          'You do not have permission to access this module',
          SweetAlertIcon.ERROR
        );

        if (
          normalizedRole === normalizedAdmin ||
          normalizedRole === normalizedDashboardAdmin
        ) {
          this.router.navigate(['/admindashboard']);
        } else if (normalizedRole === normalizedEvAdmin) {
          this.router.navigate(['/evReadings']);
        } else if (userRole) {
          if (normalizedRole === normalizedSgld) {
            this.router.navigate(['/sglddashboard']);
          } else if (normalizedRole === normalizedDashboardAdmin) {
            this.router.navigate(['/admindashboard']);
          } else if (normalizedRole === normalizedEvAdmin) {
            this.router.navigate(['/evReadings']);
          } else if (
            normalizedRole === normalizedSuperAdmin ||
            normalizedRole === normalizedSuperUser
          ) {
            this.router.navigate(['/dashboard']);
          } else if (normalizedRole === normalizedConsumer) {
            this.router.navigate(['/consumerdashboard']);
          } else if (normalizedRole === normalizedAgentAdmin) {
            this.router.navigate(['/metersDatabase']);
          } else {
            this.router.navigate(['/dashboard']);
          }
          return false;
        } else if (
          normalizedRole === normalizedSuperAdmin ||
          normalizedRole === normalizedSuperUser
        ) {
          this.router.navigate(['/dashboard']);
        } else if (normalizedRole === normalizedConsumer) {
          this.router.navigate(['/consumerdashboard']);
        } else {
          this.router.navigate(['/dashboard']);
        }

        return false;
      })
    );
  }

}
